import React, { useEffect, useState } from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import {useBranding} from "../../../hooks/useBranding";


function Callback(props: any) {
    const { branding } = useBranding()
    const [_html, setHtml] = useState("");

    
    let template = `<!DOCTYPE html>
<html style="font-size: 16px;">

<head>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta charset="utf-8">
    <meta name="keywords" content="Hosting is even better with all these FREE features, 1, 2, 3, 4, 5, 6, Projec​ts, Meet The Team Our Professionals, Read what our customers say, Subscribe And Follow Us">
    <meta name="description" content="">
    <meta name="page_type" content="np-template-header-footer-from-plugin">
    <title>${branding.appName}</title>
    <link rel="stylesheet" href="splash/nicepage.css" media="screen">
    <script class="u-script" type="text/javascript" src="https://code.jquery.com/jquery-3.5.0.js" defer=""></script>
    <script class="u-script" type="text/javascript" src="splash/nicepage.js" defer=""></script>
    <meta name="generator" content="Nicepage 3.23.1, nicepage.com">
    <link id="u-theme-google-font" rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i|Open+Sans:300,300i,400,400i,600,600i,700,700i,800,800i">
    <link id="u-page-google-font" rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i">
    <script type="application/ld+json">
        {
            "@context": "http://schema.org",
            "@type": "Organization",
            "name": "",
            "logo": "images/kim_col_rgb_188x100.jpg"
        }
    </script>
    <meta name="theme-color" content="#478ac9">
    <meta property="og:title" content=">Kim-Documents">
    <meta property="og:type" content="website">
    <style>
        .u-header-logo {
            background-image: url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNTAgODIiPjxwYXRoIGQ9Ik03MS40MSwxMi4xQTguNDMsOC40MywwLDEsMCw2MywyMC41M2E4LjQ0LDguNDQsMCwwLDAsOC40My04LjQzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIiBzdHlsZT0iZmlsbDojZmZmO2ZpbGwtcnVsZTpldmVub2RkIi8+PHBhdGggZD0iTTEzNy41NywzOS42N0ExOS45LDE5LjksMCwwLDAsMTM0LDMyLjczYTE3LjksMTcuOSwwLDAsMC02LjE2LTQuODgsMjIuNTQsMjIuNTQsMCwwLDAtMTkuNTEuNzgsMTkuMDksMTkuMDksMCwwLDAtNi43OSw2Ljg5LDE4LjY0LDE4LjY0LDAsMCwwLTYtNi43MUExOC4zNiwxOC4zNiwwLDAsMCw4NS4xMywyNmExOS44MSwxOS44MSwwLDAsMC01LjkzLjg0LDE3LjM3LDE3LjM3LDAsMCwwLTQuNzgsMi4zLDE5LjMyLDE5LjMyLDAsMCwwLTMuNTgsMy4yNWMtLjMxLjM3LS42Ljc2LS44OCwxLjE0VjQ4LjIxYy4xMS0uNTcuMjMtMS4xMy4zOS0xLjY5YTE0LjQ1LDE0LjQ1LDAsMCwxLDItNC40MkExMC4zOCwxMC4zOCwwLDAsMSw3NS44LDM5YTkuNzcsOS43NywwLDAsMSw0Ljk0LTEuMjFjMy4yMSwwLDUuNTgsMSw3LjA3LDMuMDdhMTMuMTQsMTMuMTQsMCwwLDEsMi4yNyw3LjkyVjc4LjQ4QTIuNDgsMi40OCwwLDAsMCw5Mi41NSw4MWg5YTIuNDgsMi40OCwwLDAsMCwyLjQ3LTIuNDdWNTEuODNhMjAuMTUsMjAuMTUsMCwwLDEsLjY0LTUsMTQuMjQsMTQuMjQsMCwwLDEsMi00LjUyQTExLjA2LDExLjA2LDAsMCwxLDExMC4yMSwzOWE5LjczLDkuNzMsMCwwLDEsNS4wNS0xLjI2QTguNDUsOC40NSwwLDAsMSwxMjAuMTIsMzksOSw5LDAsMCwxLDEyMyw0Mi4yMmExMi41OSwxMi41OSwwLDAsMSwxLjM4LDQuNDEsMzYuMzQsMzYuMzQsMCwwLDEsLjMzLDQuNzdWNzguNDhBMi40OCwyLjQ4LDAsMCwwLDEyNy4xOCw4MWg5YTIuNDgsMi40OCwwLDAsMCwyLjQ3LTIuNDdWNDcuNjdhMjkuMSwyOS4xLDAsMCwwLTEuMTEtOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwKSIgc3R5bGU9ImZpbGw6I2ZmZjtmaWxsLXJ1bGU6ZXZlbm9kZCIvPjxwYXRoIGQ9Ik02Ny40OSwyNi44N2gtOUEyLjQ2LDIuNDYsMCwwLDAsNTYsMjkuMzJWNzguNDhBMi40OCwyLjQ4LDAsMCwwLDU4LjQ2LDgxaDlBMi40OCwyLjQ4LDAsMCwwLDcwLDc4LjQ4VjI5LjMyYTIuNDYsMi40NiwwLDAsMC0yLjQ3LTIuNDUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiIHN0eWxlPSJmaWxsOiM5N2RlZmY7ZmlsbC1ydWxlOmV2ZW5vZGQiLz48cGF0aCBkPSJNNTEuMTYsNzkuMTgsMzAuNDgsNDkuNTUsNDkuMTIsMjkuMzFjMS4wNy0xLjA3LjU1LTIuMTktMS0yLjE5SDM0LjU5YTIuODEsMi44MSwwLDAsMC0yLjExLDEuMTlMMTQsNDkuNzZWMy40NEEyLjQ4LDIuNDgsMCwwLDAsMTEuNSwxaC05QTIuNDgsMi40OCwwLDAsMCwwLDMuNDR2NzVBMi40OCwyLjQ4LDAsMCwwLDIuNDcsODFoOUEyLjQ4LDIuNDgsMCwwLDAsMTQsNzguNDh2LTExbDcuNTYtOC4xOSwxNCwxOS45M0EzLjQxLDMuNDEsMCwwLDAsMzguMTksODFoMTJhMS4xMSwxLjExLDAsMCwwLDEtMS43NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwKSIgc3R5bGU9ImZpbGw6IzAwYjhmZjtmaWxsLXJ1bGU6ZXZlbm9kZCIvPjxwYXRoIGQ9Ik0xNDUuODQsODFBNC4xNyw0LjE3LDAsMSwxLDE1MCw3Ni44OCw0LjE3LDQuMTcsMCwwLDEsMTQ1Ljg0LDgxWm0wLTcuNjRhMy40OCwzLjQ4LDAsMSwwLDMuNDcsMy40OEEzLjQ3LDMuNDcsMCwwLDAsMTQ1Ljg0LDczLjRabTEuMjIsNS43OC0xLjE2LTEuNjEtLjg4LDB2MS41OWgtLjkzVjc0LjUxaDIuMDlhMS44NiwxLjg2LDAsMCwxLDEuMzUuNDcsMS40NCwxLjQ0LDAsMCwxLC40LDEsMS40MSwxLjQxLDAsMCwxLTEsMS40MmwxLjI1LDEuNzVabS0uOTQtMi40M2MuNTMsMCwuODYtLjI2Ljg2LS42OHMtLjMxLS43LS44Ny0uN0gxNDV2MS4zOFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiIHN0eWxlPSJmaWxsOiNmZmY7ZmlsbC1ydWxlOmV2ZW5vZGQiLz48cmVjdCB3aWR0aD0iMTUwIiBoZWlnaHQ9IjgyIiBzdHlsZT0iZmlsbDpub25lIi8+PC9zdmc+);
            position: absolute;
            left: 0px;
            top: 0px;
            width: 100%;
            height: 100%;
            -webkit-background-size: 100% auto;
            background-size: 100% auto;
            background-repeat: no-repeat;
            -webkit-background-position: center;
            background-position: center;
        }

        .u-section-1 {
            min-height: 888px;
            background-color: #050a1e;
        }
        
        .u-section-1 .u-image-1 {
            min-height: 512px;
            margin-top: 0;
            margin-bottom: 0;
            background-color: #050a1e;
        }
        
        .u-section-1 .u-container-layout-1 {
            padding: 0 80px;
        }
        
        .u-section-1 .u-text-1 {
            font-family: Roboto, sans-serif;
            font-weight: 700;
            font-size: 48px;
            line-height: 56px;
            letter-spacing: 0px;
            margin: 173px auto 0 auto;
            text-align: center;
            max-width: 820px;
        }
        
        .u-section-1 .u-text-2 {
            margin: 36px auto 80px auto;
            text-align: center;
            font-size: 19px;
            line-height: 25px;
            letter-spacing: 0px;
            max-width: 820px;
            font-weight: 400;
        }

        .u-section-1 .u-buttons {
            margin: 36px auto 80px auto;
            text-align: center;
            font-size: 28px;
            line-height: 40px;
            letter-spacing: 0px;
            max-width: 820px;
            font-weight: 400;

            display: -webkit-box;
            display: -ms-flexbox;
            -webkit-flex-direction: row;
            -ms-flex-direction: row;
            flex-direction: row;
            -webkit-align-items: stretch;
            -webkit-box-align: stretch;
            -ms-flex-align: stretch;
            align-items: stretch;
            -webkit-box-flex-wrap: wrap;
            -webkit-flex-wrap: wrap;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
            -webkit-align-items: center;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            -webkit-justify-content: center;
            justify-content: center;
        }
        
        .u-section-1 .u-list-1 {
            width: 912px;
            margin: -43px auto -319px;
        }
        
        .u-section-1 .u-repeater-1 {
            grid-template-columns: repeat(2, 50%);
            min-height: 362px;
            grid-gap: 0px;
        }
        
        .u-section-1 .u-list-item-1 {
            margin-top: 0;
            margin-bottom: 0;
            background-image: none;
        }
        
        .u-section-1 .u-container-layout-2 {
            padding: 30px !important;
        }
        
        .u-section-1 .u-icon-1 {
            width: 64px !important;
            height: 64px !important;
            background-image: none;
            color: rgb(255, 255, 255) !important;
            margin: 0 auto 0 0;
        }
        
        .u-section-1 .u-text-3 {
            font-weight: 500;
            text-transform: uppercase;
            letter-spacing: 1px;
            margin: -64px 0 0 91px;
        }
        
        .u-section-1 .u-text-4 {
            font-style: normal;
            margin: 18px 0 0 91px;
        }
        
        .u-section-1 .u-list-item-2 {
            margin-top: 0;
            margin-bottom: 0;
        }
        
        .u-section-1 .u-container-layout-3 {
            padding: 30px;
        }
        
        .u-section-1 .u-icon-2 {
            width: 64px;
            height: 64px;
            background-image: none;
            color: rgb(255, 255, 255) !important;
            margin: 0 auto 0 0;
        }
        
        .u-section-1 .u-text-5 {
            font-weight: 500;
            text-transform: uppercase;
            letter-spacing: 1px;
            margin: -64px 0 0 91px;
        }
        
        .u-section-1 .u-text-6 {
            font-style: normal;
            margin: 18px 0 0 91px;
        }
        
        .u-section-1 .u-list-item-3 {
            margin-top: 0;
            margin-bottom: 0;
        }
        
        .u-section-1 .u-container-layout-4 {
            padding: 30px;
        }
        
        .u-section-1 .u-icon-3 {
            width: 64px;
            height: 64px;
            background-image: none;
            color: rgb(255, 255, 255) !important;
            margin: 0 auto 0 0;
        }
        
        .u-section-1 .u-text-7 {
            font-weight: 500;
            text-transform: uppercase;
            letter-spacing: 1px;
            margin: -64px 0 0 91px;
        }
        
        .u-section-1 .u-text-8 {
            font-style: normal;
            margin: 18px 0 0 91px;
        }
        
        .u-section-1 .u-list-item-4 {
            margin-top: 0;
            margin-bottom: 0;
        }
        
        .u-section-1 .u-container-layout-5 {
            padding: 30px;
        }
        
        .u-section-1 .u-icon-4 {
            width: 64px;
            height: 64px;
            background-image: none;
            color: rgb(255, 255, 255) !important;
            margin: 0 auto 0 0;
        }
        
        .u-section-1 .u-text-9 {
            font-weight: 500;
            text-transform: uppercase;
            letter-spacing: 1px;
            margin: -64px 0 0 91px;
        }
        
        .u-section-1 .u-text-10 {
            font-style: normal;
            margin: 18px 0 0 91px;
        }
        
        @media (max-width: 1199px) {
            .u-section-1 {
                min-height: 891px;
            }
            .u-section-1 .u-list-1 {
                margin-bottom: 60px;
            }
        }
        
        @media (max-width: 991px) {
            .u-section-1 .u-container-layout-1 {
                padding-left: 30px;
                padding-right: 30px;
            }
            .u-section-1 .u-list-1 {
                width: 720px;
            }
            .u-section-1 .u-repeater-1 {
                grid-template-columns: 100%;
            }
            .u-section-1 .u-text-3 {
                width: auto;
                margin-left: 121px;
            }
            .u-section-1 .u-text-4 {
                width: auto;
                margin-left: 121px;
            }
            .u-section-1 .u-text-5 {
                width: auto;
                margin-left: 121px;
            }
            .u-section-1 .u-text-6 {
                width: auto;
                margin-left: 121px;
            }
            .u-section-1 .u-text-7 {
                width: auto;
                margin-left: 121px;
            }
            .u-section-1 .u-text-8 {
                width: auto;
                margin-left: 121px;
            }
            .u-section-1 .u-text-9 {
                width: auto;
                margin-left: 121px;
            }
            .u-section-1 .u-text-10 {
                width: auto;
                margin-left: 121px;
            }
        }
        
        @media (max-width: 767px) {
            .u-section-1 {
                min-height: 1134px;
            }
            .u-section-1 .u-image-1 {
                background-position: 0% 66.37%;
            }
            .u-section-1 .u-container-layout-1 {
                padding-left: 50px;
                padding-right: 50px;
            }
            .u-section-1 .u-list-1 {
                width: 540px;
            }
            .u-section-1 .u-container-layout-2 {
                padding-left: 10px;
                padding-right: 10px;
            }
            .u-section-1 .u-container-layout-3 {
                padding-left: 10px;
                padding-right: 10px;
            }
            .u-section-1 .u-container-layout-4 {
                padding-left: 10px;
                padding-right: 10px;
            }
            .u-section-1 .u-container-layout-5 {
                padding-left: 10px;
                padding-right: 10px;
            }
        }
        
        @media (max-width: 575px) {
            .u-section-1 {
                min-height: 1358px;
            }
            .u-section-1 .u-container-layout-1 {
                padding-left: 12px;
                padding-right: 12px;
            }
            .u-section-1 .u-list-1 {
                width: 340px;
            }
            .u-section-1 .u-text-3 {
                margin-left: 74px;
            }
            .u-section-1 .u-text-4 {
                margin-left: 74px;
            }
            .u-section-1 .u-text-5 {
                margin-left: 74px;
            }
            .u-section-1 .u-text-6 {
                margin-left: 74px;
            }
            .u-section-1 .u-text-7 {
                margin-left: 74px;
            }
            .u-section-1 .u-text-8 {
                margin-left: 74px;
            }
            .u-section-1 .u-text-9 {
                margin-left: 74px;
            }
            .u-section-1 .u-text-10 {
                margin-left: 74px;
            }
        }
        
        .u-section-2 {
            background-image: none;
        }
        
        .u-section-2 .u-sheet-1 {
            min-height: 331px;
        }
        
        .u-section-2 .u-text-1 {
            font-weight: 700;
            width: 803px;
            margin: 60px auto 0;
        }
        
        .u-section-2 .u-text-2 {
            width: 803px;
            font-size: 1.125rem;
            margin: 28px auto 60px;
        }
        
        @media (max-width: 991px) {
            .u-section-2 .u-text-1 {
                width: 720px;
            }
            .u-section-2 .u-text-2 {
                width: 720px;
            }
        }
        
        @media (max-width: 767px) {
            .u-section-2 .u-text-1 {
                width: 540px;
            }
            .u-section-2 .u-text-2 {
                width: 540px;
            }
        }
        
        @media (max-width: 575px) {
            .u-section-2 .u-text-1 {
                width: 340px;
            }
            .u-section-2 .u-text-2 {
                width: 340px;
            }
        }
        
        .u-section-3 .u-sheet-1 {
            min-height: 646px;
        }
        
        .u-section-3 .u-list-1 {
            width: 912px;
            margin: 75px auto 60px;
        }
        
        .u-section-3 .u-repeater-1 {
            grid-template-columns: repeat(2, calc(50% - 10px));
            min-height: 497px;
            grid-gap: 20px;
        }
        
        .u-section-3 .u-list-item-1 {
            background-image: none;
        }
        
        .u-section-3 .u-container-layout-1 {
            padding: 2px 30px;
        }
        
        .u-section-3 .u-text-1 {
            margin-top: 10px;
            font-size: 1.5rem;
            font-weight: 700;
            margin-bottom: 0;
        }
        
        .u-section-3 .u-text-2 {
            margin: -20px 15px -5px 64px;
        }
        
        .u-section-3 .u-list-item-2 {
            background-image: none;
        }
        
        .u-section-3 .u-container-layout-2 {
            padding: 2px 30px;
        }
        
        .u-section-3 .u-text-3 {
            margin-top: 10px;
            font-size: 1.5rem;
            font-weight: 700;
            margin-bottom: 0;
        }
        
        .u-section-3 .u-text-4 {
            margin: -20px 15px -5px 64px;
        }
        
        .u-section-3 .u-container-layout-3 {
            padding: 2px 30px;
        }
        
        .u-section-3 .u-text-5 {
            margin-top: 10px;
            font-size: 1.5rem;
            font-weight: 700;
            margin-bottom: 0;
        }
        
        .u-section-3 .u-text-6 {
            margin: -20px 15px -5px 64px;
        }
        
        .u-section-3 .u-container-layout-4 {
            padding: 2px 30px;
        }
        
        .u-section-3 .u-text-7 {
            margin-top: 10px;
            font-size: 1.5rem;
            font-weight: 700;
            margin-bottom: 0;
        }
        
        .u-section-3 .u-text-8 {
            margin: -20px 15px -5px 64px;
        }
        
        .u-section-3 .u-list-item-5 {
            background-image: none;
        }
        
        .u-section-3 .u-container-layout-5 {
            padding: 2px 30px;
        }
        
        .u-section-3 .u-text-9 {
            margin-top: 10px;
            font-size: 1.5rem;
            font-weight: 700;
            margin-bottom: 0;
        }
        
        .u-section-3 .u-text-10 {
            margin: -20px 15px -5px 64px;
        }
        
        .u-section-3 .u-list-item-6 {
            background-image: none;
        }
        
        .u-section-3 .u-container-layout-6 {
            padding: 2px 30px;
        }
        
        .u-section-3 .u-text-11 {
            margin-top: 10px;
            font-size: 1.5rem;
            font-weight: 700;
            margin-bottom: 0;
        }
        
        .u-section-3 .u-text-12 {
            margin: -20px 15px -5px 64px;
        }
        
        @media (max-width: 1199px) {
            .u-section-3 .u-sheet-1 {
                min-height: 617px;
            }
            .u-section-3 .u-list-1 {
                margin-top: 60px;
                margin-bottom: 46px;
            }
        }
        
        @media (max-width: 991px) {
            .u-section-3 .u-sheet-1 {
                min-height: 1090px;
            }
            .u-section-3 .u-list-1 {
                width: 720px;
                margin-bottom: -60px;
            }
            .u-section-3 .u-repeater-1 {
                grid-template-columns: 100%;
            }
            .u-section-3 .u-text-2 {
                margin-top: 20px;
                margin-right: 0;
                margin-left: 0;
            }
            .u-section-3 .u-text-4 {
                margin-top: 20px;
                margin-right: 0;
                margin-left: 0;
            }
            .u-section-3 .u-text-6 {
                margin-top: 20px;
                margin-right: 0;
                margin-left: 0;
            }
            .u-section-3 .u-text-8 {
                margin-top: 20px;
                margin-right: 0;
                margin-left: 0;
            }
            .u-section-3 .u-text-10 {
                margin-top: 20px;
                margin-right: 0;
                margin-left: 0;
            }
            .u-section-3 .u-text-12 {
                margin-top: 20px;
                margin-right: 0;
                margin-left: 0;
            }
        }
        
        @media (max-width: 767px) {
            .u-section-3 .u-list-1 {
                width: 540px;
            }
            .u-section-3 .u-container-layout-1 {
                padding-left: 10px;
                padding-right: 10px;
            }
            .u-section-3 .u-container-layout-2 {
                padding-left: 10px;
                padding-right: 10px;
            }
            .u-section-3 .u-container-layout-3 {
                padding-left: 10px;
                padding-right: 10px;
            }
            .u-section-3 .u-container-layout-4 {
                padding-left: 10px;
                padding-right: 10px;
            }
            .u-section-3 .u-container-layout-5 {
                padding-left: 10px;
                padding-right: 10px;
            }
            .u-section-3 .u-container-layout-6 {
                padding-left: 10px;
                padding-right: 10px;
            }
        }
        
        @media (max-width: 575px) {
            .u-section-3 .u-sheet-1 {
                min-height: 1210px;
            }
            .u-section-3 .u-list-1 {
                width: 340px;
                margin-bottom: 60px;
            }
        }
        
        .u-section-4 {
            background-image: none;
        }
        
        .u-section-4 .u-sheet-1 {
            min-height: 331px;
        }
        
        .u-section-4 .u-text-1 {
            font-weight: 700;
            width: 803px;
            margin: 60px auto 0;
        }
        
        .u-section-4 .u-text-2 {
            width: 803px;
            font-size: 1.125rem;
            margin: 28px auto 60px;
        }
        
        @media (max-width: 991px) {
            .u-section-4 .u-text-1 {
                width: 720px;
            }
            .u-section-4 .u-text-2 {
                width: 720px;
            }
        }
        
        @media (max-width: 767px) {
            .u-section-4 .u-text-1 {
                width: 540px;
            }
            .u-section-4 .u-text-2 {
                width: 540px;
            }
        }
        
        @media (max-width: 575px) {
            .u-section-4 .u-text-1 {
                width: 340px;
            }
            .u-section-4 .u-text-2 {
                width: 340px;
            }
        }
        
        .u-section-5 .u-sheet-1 {
            min-height: 760px;
        }
        
        .u-section-5 .u-gallery-1 {
            height: 561px;
            width: 912px;
            margin: 139px auto 47px;
        }
        
        .u-section-5 .u-gallery-inner-1 {
            grid-template-columns: repeat(2, auto);
            grid-gap: 40px;
        }
        
        .u-section-5 .u-over-slide-1 {
            background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
            padding: 20px;
        }
        
        .u-section-5 .u-over-slide-2 {
            background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
            padding: 20px;
        }
        
        .u-section-5 .u-over-slide-3 {
            background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
            padding: 20px;
        }
        
        .u-section-5 .u-over-slide-4 {
            background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
            padding: 20px;
        }
        
        @media (max-width: 991px) {
            .u-section-5 .u-sheet-1 {
                min-height: 1971px;
            }
            .u-section-5 .u-gallery-1 {
                height: 1772px;
                width: 720px;
            }
            .u-section-5 .u-gallery-inner-1 {
                grid-template-columns: repeat(1, auto);
            }
        }
        
        @media (max-width: 767px) {
            .u-section-5 .u-sheet-1 {
                min-height: 1528px;
            }
            .u-section-5 .u-gallery-1 {
                height: 1329px;
                width: 540px;
            }
        }
        
        @media (max-width: 575px) {
            .u-section-5 .u-sheet-1 {
                min-height: 1036px;
            }
            .u-section-5 .u-gallery-1 {
                height: 837px;
                width: 340px;
            }
        }
        
        .u-section-6 {
            background-image: none;
        }
        
        .u-section-6 .u-sheet-1 {
            min-height: 331px;
        }
        
        .u-section-6 .u-text-1 {
            font-weight: 700;
            width: 803px;
            margin: 60px auto 0;
        }
        
        .u-section-6 .u-text-2 {
            width: 803px;
            font-size: 1.125rem;
            margin: 28px auto 60px;
        }
        
        @media (max-width: 991px) {
            .u-section-6 .u-text-1 {
                width: 720px;
            }
            .u-section-6 .u-text-2 {
                width: 720px;
            }
        }
        
        @media (max-width: 767px) {
            .u-section-6 .u-text-1 {
                width: 540px;
            }
            .u-section-6 .u-text-2 {
                width: 540px;
            }
        }
        
        @media (max-width: 575px) {
            .u-section-6 .u-text-1 {
                width: 340px;
            }
            .u-section-6 .u-text-2 {
                width: 340px;
            }
        }
        
        .u-section-7 {
            background-image: none;
        }
        
        .u-section-7 .u-sheet-1 {
            min-height: 856px;
        }
        
        .u-section-7 .u-image-1 {
            width: 1060px;
            height: 506px;
            margin: 75px 9px 60px auto;
        }
        
        @media (max-width: 1199px) {
            .u-section-7 .u-sheet-1 {
                min-height: 799px;
            }
            .u-section-7 .u-image-1 {
                width: 940px;
                height: 449px;
                margin-right: 0;
            }
        }
        
        @media (max-width: 991px) {
            .u-section-7 .u-sheet-1 {
                min-height: 694px;
            }
            .u-section-7 .u-image-1 {
                width: 720px;
                height: 344px;
            }
        }
        
        @media (max-width: 767px) {
            .u-section-7 .u-sheet-1 {
                min-height: 608px;
            }
            .u-section-7 .u-image-1 {
                width: 540px;
                height: 258px;
            }
        }
        
        @media (max-width: 575px) {
            .u-section-7 .u-sheet-1 {
                min-height: 512px;
            }
            .u-section-7 .u-image-1 {
                width: 340px;
                height: 162px;
            }
        }
        
        .u-section-8 {
            background-image: none;
        }
        
        .u-section-8 .u-sheet-1 {
            min-height: 331px;
        }
        
        .u-section-8 .u-text-1 {
            font-weight: 700;
            width: 803px;
            margin: 60px auto 0;
        }
        
        .u-section-8 .u-text-2 {
            width: 803px;
            font-size: 1.125rem;
            margin: 28px auto 60px;
        }
        
        @media (max-width: 991px) {
            .u-section-8 .u-text-1 {
                width: 720px;
            }
            .u-section-8 .u-text-2 {
                width: 720px;
            }
        }
        
        @media (max-width: 767px) {
            .u-section-8 .u-text-1 {
                width: 540px;
            }
            .u-section-8 .u-text-2 {
                width: 540px;
            }
        }
        
        @media (max-width: 575px) {
            .u-section-8 .u-text-1 {
                width: 340px;
            }
            .u-section-8 .u-text-2 {
                width: 340px;
            }
        }
        
        .u-section-9 .u-sheet-1 {
            min-height: 500px;
        }
        
        .u-section-9 .u-image-1 {
            width: 570px;
            height: 648px;
            margin: -74px auto 60px;
        }
        
        @media (max-width: 767px) {
            .u-section-9 .u-sheet-1 {
                min-height: 466px;
            }
            .u-section-9 .u-image-1 {
                width: 540px;
                height: 614px;
            }
        }
        
        @media (max-width: 575px) {
            .u-section-9 .u-sheet-1 {
                min-height: 239px;
            }
            .u-section-9 .u-image-1 {
                width: 340px;
                height: 387px;
            }
        }
        
        .u-section-10 {
            background-image: none;
        }
        
        .u-section-10 .u-sheet-1 {
            min-height: 331px;
        }
        
        .u-section-10 .u-text-1 {
            font-weight: 700;
            width: 803px;
            margin: 60px auto 0;
        }
        
        .u-section-10 .u-text-2 {
            width: 803px;
            font-size: 1.125rem;
            margin: 28px auto 60px;
        }
        
        @media (max-width: 991px) {
            .u-section-10 .u-text-1 {
                width: 720px;
            }
            .u-section-10 .u-text-2 {
                width: 720px;
            }
        }
        
        @media (max-width: 767px) {
            .u-section-10 .u-text-1 {
                width: 540px;
            }
            .u-section-10 .u-text-2 {
                width: 540px;
            }
        }
        
        @media (max-width: 575px) {
            .u-section-10 .u-text-1 {
                width: 340px;
            }
            .u-section-10 .u-text-2 {
                width: 340px;
            }
        }
        
        .u-section-11 .u-sheet-1 {
            min-height: 500px;
        }
        
        .u-section-11 .u-image-1 {
            width: 570px;
            height: 351px;
            margin: 79px auto 60px 198px;
        }
        
        @media (max-width: 991px) {
            .u-section-11 .u-image-1 {
                margin-left: 150px;
            }
        }
        
        @media (max-width: 767px) {
            .u-section-11 .u-sheet-1 {
                min-height: 481px;
            }
            .u-section-11 .u-image-1 {
                width: 540px;
                height: 332px;
                margin-left: 0;
            }
        }
        
        @media (max-width: 575px) {
            .u-section-11 .u-sheet-1 {
                min-height: 358px;
            }
            .u-section-11 .u-image-1 {
                width: 340px;
                height: 209px;
            }
        }
        
        .u-section-12 {
            background-image: none;
        }
        
        .u-section-12 .u-sheet-1 {
            min-height: 331px;
        }
        
        .u-section-12 .u-text-1 {
            font-weight: 700;
            width: 803px;
            margin: 60px auto 0;
        }
        
        .u-section-12 .u-text-2 {
            width: 803px;
            font-size: 1.125rem;
            margin: 28px auto 60px;
        }
        
        @media (max-width: 991px) {
            .u-section-12 .u-text-1 {
                width: 720px;
            }
            .u-section-12 .u-text-2 {
                width: 720px;
            }
        }
        
        @media (max-width: 767px) {
            .u-section-12 .u-text-1 {
                width: 540px;
            }
            .u-section-12 .u-text-2 {
                width: 540px;
            }
        }
        
        @media (max-width: 575px) {
            .u-section-12 .u-text-1 {
                width: 340px;
            }
            .u-section-12 .u-text-2 {
                width: 340px;
            }
        }
        
        .u-section-13 .u-sheet-1 {
            min-height: 665px;
        }
        
        .u-section-13 .u-image-1 {
            width: 570px;
            height: 600px;
            margin: 65px auto 0;
        }
        
        @media (max-width: 767px) {
            .u-section-13 .u-sheet-1 {
                min-height: 634px;
            }
            .u-section-13 .u-image-1 {
                width: 540px;
                height: 569px;
            }
        }
        
        @media (max-width: 575px) {
            .u-section-13 .u-sheet-1 {
                min-height: 423px;
            }
            .u-section-13 .u-image-1 {
                width: 340px;
                height: 358px;
            }
        }
        
        .u-section-14 {
            background-image: none;
        }
        
        .u-section-14 .u-sheet-1 {
            min-height: 331px;
        }
        
        .u-section-14 .u-text-1 {
            font-weight: 700;
            width: 803px;
            margin: 60px auto 0;
        }
        
        .u-section-14 .u-text-2 {
            width: 803px;
            font-size: 1.125rem;
            margin: 28px auto 60px;
        }
        
        @media (max-width: 991px) {
            .u-section-14 .u-text-1 {
                width: 720px;
            }
            .u-section-14 .u-text-2 {
                width: 720px;
            }
        }
        
        @media (max-width: 767px) {
            .u-section-14 .u-text-1 {
                width: 540px;
            }
            .u-section-14 .u-text-2 {
                width: 540px;
            }
        }
        
        @media (max-width: 575px) {
            .u-section-14 .u-text-1 {
                width: 340px;
            }
            .u-section-14 .u-text-2 {
                width: 340px;
            }
        }
        
        .u-section-15 .u-sheet-1 {
            min-height: 500px;
        }
        
        .u-section-15 .u-image-1 {
            width: 1082px;
            height: 329px;
            margin: 15px auto 60px;
        }
        
        @media (max-width: 1199px) {
            .u-section-15 .u-image-1 {
                width: 940px;
                height: 286px;
            }
        }
        
        @media (max-width: 991px) {
            .u-section-15 .u-image-1 {
                width: 720px;
                height: 219px;
            }
        }
        
        @media (max-width: 767px) {
            .u-section-15 .u-sheet-1 {
                min-height: 491px;
            }
            .u-section-15 .u-image-1 {
                width: 540px;
                height: 164px;
            }
        }
        
        @media (max-width: 575px) {
            .u-section-15 .u-sheet-1 {
                min-height: 430px;
            }
            .u-section-15 .u-image-1 {
                width: 340px;
                height: 103px;
            }
        }
        
        .u-section-16 {
            background-image: none;
        }
        
        .u-section-16 .u-sheet-1 {
            min-height: 331px;
        }
        
        .u-section-16 .u-text-1 {
            font-weight: 700;
            width: 803px;
            margin: 60px auto 0;
        }
        
        .u-section-16 .u-text-2 {
            width: 803px;
            font-size: 1.125rem;
            margin: 28px auto 60px;
        }
        
        @media (max-width: 991px) {
            .u-section-16 .u-text-1 {
                width: 720px;
            }
            .u-section-16 .u-text-2 {
                width: 720px;
            }
        }
        
        @media (max-width: 767px) {
            .u-section-16 .u-text-1 {
                width: 540px;
            }
            .u-section-16 .u-text-2 {
                width: 540px;
            }
        }
        
        @media (max-width: 575px) {
            .u-section-16 .u-text-1 {
                width: 340px;
            }
            .u-section-16 .u-text-2 {
                width: 340px;
            }
        }
        
        .u-section-17 .u-sheet-1 {
            min-height: 500px;
        }
        
        .u-section-17 .u-image-1 {
            width: 859px;
            height: 481px;
            margin: 10px auto;
        }
        
        @media (max-width: 991px) {
            .u-section-17 .u-sheet-1 {
                min-height: 422px;
            }
            .u-section-17 .u-image-1 {
                width: 720px;
                height: 403px;
            }
        }
        
        @media (max-width: 767px) {
            .u-section-17 .u-sheet-1 {
                min-height: 321px;
            }
            .u-section-17 .u-image-1 {
                width: 540px;
                height: 302px;
            }
        }
        
        @media (max-width: 575px) {
            .u-section-17 .u-sheet-1 {
                min-height: 209px;
            }
            .u-section-17 .u-image-1 {
                width: 340px;
                height: 190px;
            }
        }
        
        .u-section-18 {
            background-image: none;
        }
        
        .u-section-18 .u-sheet-1 {
            min-height: 331px;
        }
        
        .u-section-18 .u-text-1 {
            font-weight: 700;
            width: 803px;
            margin: 60px auto 0;
        }
        
        .u-section-18 .u-text-2 {
            width: 803px;
            font-size: 1.125rem;
            margin: 28px auto 60px;
        }
        
        @media (max-width: 991px) {
            .u-section-18 .u-text-1 {
                width: 720px;
            }
            .u-section-18 .u-text-2 {
                width: 720px;
            }
        }
        
        @media (max-width: 767px) {
            .u-section-18 .u-text-1 {
                width: 540px;
            }
            .u-section-18 .u-text-2 {
                width: 540px;
            }
        }
        
        @media (max-width: 575px) {
            .u-section-18 .u-text-1 {
                width: 340px;
            }
            .u-section-18 .u-text-2 {
                width: 340px;
            }
        }
        
        .u-section-19 .u-sheet-1 {
            min-height: 500px;
        }
        
        .u-section-19 .u-image-1 {
            width: 989px;
            height: 462px;
            margin: 10px auto 28px;
        }
        
        @media (max-width: 1199px) {
            .u-section-19 .u-sheet-1 {
                min-height: 477px;
            }
            .u-section-19 .u-image-1 {
                width: 940px;
                height: 439px;
            }
        }
        
        @media (max-width: 991px) {
            .u-section-19 .u-sheet-1 {
                min-height: 374px;
            }
            .u-section-19 .u-image-1 {
                width: 720px;
                height: 336px;
            }
        }
        
        @media (max-width: 767px) {
            .u-section-19 .u-sheet-1 {
                min-height: 290px;
            }
            .u-section-19 .u-image-1 {
                width: 540px;
                height: 252px;
            }
        }
        
        @media (max-width: 575px) {
            .u-section-19 .u-sheet-1 {
                min-height: 197px;
            }
            .u-section-19 .u-image-1 {
                width: 340px;
                height: 159px;
            }
        }
        
        .u-section-20 {
            background-image: none;
        }
        
        .u-section-20 .u-sheet-1 {
            min-height: 331px;
        }
        
        .u-section-20 .u-text-1 {
            font-weight: 700;
            width: 803px;
            margin: 60px auto 0;
        }
        
        .u-section-20 .u-text-2 {
            width: 803px;
            font-size: 1.125rem;
            margin: 28px auto 60px;
        }
        
        @media (max-width: 991px) {
            .u-section-20 .u-text-1 {
                width: 720px;
            }
            .u-section-20 .u-text-2 {
                width: 720px;
            }
        }
        
        @media (max-width: 767px) {
            .u-section-20 .u-text-1 {
                width: 540px;
            }
            .u-section-20 .u-text-2 {
                width: 540px;
            }
        }
        
        @media (max-width: 575px) {
            .u-section-20 .u-text-1 {
                width: 340px;
            }
            .u-section-20 .u-text-2 {
                width: 340px;
            }
        }
        
        .u-section-21 .u-sheet-1 {
            min-height: 500px;
        }
        
        .u-section-21 .u-image-1 {
            width: 1014px;
            height: 301px;
            margin: 11px auto 60px;
        }
        
        @media (max-width: 1199px) {
            .u-section-21 .u-sheet-1 {
                min-height: 478px;
            }
            .u-section-21 .u-image-1 {
                width: 940px;
                height: 279px;
            }
        }
        
        @media (max-width: 991px) {
            .u-section-21 .u-sheet-1 {
                min-height: 413px;
            }
            .u-section-21 .u-image-1 {
                width: 720px;
                height: 214px;
            }
        }
        
        @media (max-width: 767px) {
            .u-section-21 .u-sheet-1 {
                min-height: 360px;
            }
            .u-section-21 .u-image-1 {
                width: 540px;
                height: 161px;
            }
        }
        
        @media (max-width: 575px) {
            .u-section-21 .u-sheet-1 {
                min-height: 300px;
            }
            .u-section-21 .u-image-1 {
                width: 340px;
                height: 101px;
            }
        }
        
        .u-section-22 {
            background-image: none;
        }
        
        .u-section-22 .u-sheet-1 {
            min-height: 458px;
        }
        
        .u-section-22 .u-text-1 {
            text-transform: uppercase;
            letter-spacing: 2px;
            margin: 0 auto;
        }
        
        .u-section-22 .u-text-2 {
            font-size: 3.75rem;
            font-weight: 400;
            margin: 37px auto 0;
        }

        .u-buttons {
            margin-bottom: 16px;
            text-align: center;
        }

        .u-button-1 {
            cursor: pointer;
            position: relative;
            font-family: 'Roobert-Medium','Helvetica Neue',Helvetica,Arial,sans-serif;
            font-weight: 400;
            font-size: 19px;
            line-height: 25px;
            letter-spacing: 0px;
            text-transform: none;
            font-weight: 400;
            background-color: #f1f5ff;
            padding-left: 28px;
            padding-right: 28px;
            padding-top: 13px;
            padding-bottom: 13px;
            display: inline-block;
            border-radius: 100px;
            overflow: hidden;
            white-space: nowrap;
            -webkit-appearance: none;
            border: none;
            margin-right: 16px;
            width: 100%;
        }

        .u-button-2 {
            position: relative;
            font-family: 'Roobert-Medium','Helvetica Neue',Helvetica,Arial,sans-serif;
            font-weight: 400;
            font-size: 19px;
            line-height: 25px;
            letter-spacing: 0px;
            text-transform: none;
            padding-left: 28px;
            padding-right: 28px;
            padding-top: 13px;
            padding-bottom: 13px;
            display: inline-block;
            border-radius: 100px;
            overflow: hidden;
            white-space: nowrap;
            -webkit-appearance: none;
            border: none;
            background-color: #00dd28;
            background: linear-gradient(90deg, #00dd28 0%, #008eff 100%);
            margin-right: 16px;
            width: 100%;
        }

        .u-button-3 {
            position: relative;
            font-family: 'Roobert-Medium','Helvetica Neue',Helvetica,Arial,sans-serif;
            font-weight: 400;
            font-size: 19px;
            line-height: 25px;
            letter-spacing: 0px;
            text-transform: none;
            padding-left: 28px;
            padding-right: 28px;
            padding-top: 13px;
            padding-bottom: 13px;
            display: inline-block;
            border-radius: 100px;
            overflow: hidden;
            white-space: nowrap;
            -webkit-appearance: none;
            border: none;
            background-color: #fa0071;
            background: linear-gradient(90deg, #fa0071 0%, #9600fa 100%);
            width: 100%;
        }

        .u-buttontext-1 {
            z-index: 50;
            color: #050a1e;
            -webkit-transition: color 0.3s ease-in-out;
            transition: color 0.3s ease-in-out;
        }

        .u-FlexInfoColumns-1 {
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-flex-direction: row;
            -ms-flex-direction: row;
            flex-direction: row;
            -webkit-align-items: flex-start;
            -webkit-box-align: flex-start;
            -ms-flex-align: flex-start;
            align-items: flex-start;
            -webkit-box-flex-wrap: wrap;
            -webkit-flex-wrap: wrap;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
            margin-left: -8px;
            margin-right: -8px;
            margin-bottom: -16px;
            -webkit-align-items: stretch;
            -webkit-box-align: stretch;
            -ms-flex-align: stretch;
            align-items: stretch;
            max-width: 1480px;
            margin: 36px auto 180px auto;
        }

        .u-FlexInfoContainer {
            position: relative;
            width: 100%;
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-align-items: stretch;
            -webkit-box-align: stretch;
            -ms-flex-align: stretch;
            align-items: stretch;
            padding-bottom: 20px;
        }

        .u-FlexInfoBox {
            background-color: #c5c9e2;
            color: #050a1e;
            border-radius: 24px;
            padding-left: 20px;
            padding-right: 20px;
            padding-top: 20px;
            padding-bottom: 20px;
        }

        .u-FlexInfoContent {
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-flex-direction: column;
            -ms-flex-direction: column;
            flex-direction: column;
            -webkit-align-items: stretch;
            -webkit-box-align: stretch;
            -ms-flex-align: stretch;
            align-items: stretch;
        }

        .u-FlexInfoTextContainer {
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-flex-direction: column;
            -ms-flex-direction: column;
            flex-direction: column;
            -webkit-align-items: stretch;
            -webkit-box-align: stretch;
            -ms-flex-align: stretch;
            align-items: stretch;
        }

        .u-InfoHeader-1 {
            font-family: 'Roobert-Bold','Helvetica Neue',Helvetica,Arial,sans-serif;
            font-weight: 700;
            font-size: 28px;
            line-height: 40px;
            letter-spacing: 0px;
            text-transform: none;
            max-width: 820px;
        }

        .u-InfoText {
            font-family: 'Roobert-Medium','Helvetica Neue',Helvetica,Arial,sans-serif;
            font-weight: 400;
            font-size: 19px;
            line-height: 25px;
            letter-spacing: 0px;
            text-transform: none;
            max-width: 960px;
        }
        

        @media (min-width: 1440px) {
            .u-FlexInfoBox {
                padding-left: 120px;
                padding-right: 120px;
            }
        }

        @media (min-width: 1024px) {
            .u-FlexInfoContainer {
                width: 50%;
            }
            .u-FlexInfoBox {
                padding-left: 80px;
                padding-right: 80px;
                padding-top: 80px;
                padding-bottom: 80px;
            }
        }

        @media (min-width: 820px) {
            .u-button-1 {
                font-size: 28px;
                line-height: 40px;
                letter-spacing: 0px;
                margin-right: 16px;
            }
            .u-button-2 {
                font-size: 28px;
                line-height: 40px;
                letter-spacing: 0px;
                margin-right: 16px;
            }
            .u-button-3 {
                font-size: 28px;
                line-height: 40px;
                letter-spacing: 0px;
            }
            .u-section-1 .u-text-1 {
                font-size: 82px;
                line-height: 78px;
                letter-spacing: 0px;
            }
            .u-section-1 .u-text-2 {
                font-size: 28px;
                line-height: 40px;
                letter-spacing: 0px;
            }
            .u-FlexInfoBox {
                padding-left: 80px;
                padding-right: 80px;
                padding-top: 80px;
                padding-bottom: 80px;
            }
            .u-InfoHeader-1 {
                font-size: 48px;
                line-height: 56px;
                letter-spacing: 0px;
            }
            .u-InfoText {
                font-size: 28px;
                line-height: 40px;
                letter-spacing: 0px;
            }
        }

        @media (min-width: 480px) {
            .u-button-1 {
                font-size: 23px;
                line-height: 30px;
                letter-spacing: 0px;
                margin-right: 16px;
                width: auto;
            }
            .u-button-2 {
                font-size: 23px;
                line-height: 30px;
                letter-spacing: 0px;
                margin-right: 16px;
                width: auto;
            }
            .u-button-3 {
                font-size: 23px;
                line-height: 30px;
                letter-spacing: 0px;
                width: auto;
            }
            .u-section-1 .u-text-2 {
                font-size: 23px;
                line-height: 30px;
                letter-spacing: 0px;
            }
            .u-buttons {
                text-align: inherit;
                display: -webkit-flex;
                display: flex;
            }
            .u-FlexInfoContainer {
                padding-left: 20px;
                padding-right: 20px;
                padding-bottom: 40px;
            }
            .u-FlexInfoBox {
                padding-left: 40px;
                padding-right: 40px;
                padding-top: 40px;
                padding-bottom: 40px;;
            }
            .u-InfoHeader-1 {
                font-size: 36px;
                line-height: 42px;
                letter-spacing: 0px;
            }
            .u-InfoText {
                font-size: 23px;
                line-height: 30px;
                letter-spacing: 0px;
            }
        }
        
        .button-SplashGS {
            background-color: #0078d0;
            border: 0;
            border-radius: 56px;
            color: #fff;
            cursor: pointer;
            display: inline-block;
            font-family: system-ui, -apple-system, system-ui, "Segoe UI", Roboto, Ubuntu, "Helvetica Neue", sans-serif;
            font-size: 18px;
            font-weight: 600;
            outline: 0;
            padding: 16px 21px;
            position: relative;
            text-align: center;
            text-decoration: none;
            transition: all .3s;
            user-select: none;
            -webkit-user-select: none;
            touch-action: manipulation;
            margin: -7vh 0 22px auto;
        }
        
        .button-SplashGS:before {
            background-color: initial;
            background-image: linear-gradient(#fff 0, rgba(255, 255, 255, 0) 100%);
            border-radius: 125px;
            color: #fff;
            content: "";
            height: 50%;
            left: 4%;
            opacity: .5;
            position: absolute;
            top: 0;
            transition: all .3s;
            width: 92%;
        }
        
        .button-SplashGS:hover {
            box-shadow: rgba(255, 255, 255, .2) 0 3px 15px inset, rgba(0, 0, 0, .1) 0 3px 5px, rgba(0, 0, 0, .1) 0 10px 13px;
            transform: scale(1.05);
            color:#e9f2fa;
            background-color:#1b44a1;
        }
        
        @media (min-width: 768px) {
            .button-SplashGS {
                padding: 16px 48px;
            }
        }
        
        @media (max-width: 767px) {
            .u-section-22 .u-text-1 {
                margin-top: 60px;
            }
            .u-section-22 .u-text-2 {
                margin-bottom: 60px;
            }
        }
        
        @media (max-width: 575px) {
            .u-section-22 .u-text-2 {
                font-size: 2.25rem;
            }
        }
    </style>
</head>

<body class="u-body">
    <header class="u-clearfix u-header u-header" id="sec-92c4">
        <div class="u-clearfix u-sheet u-valign-middle u-sheet-1">
            <a href="https://www.kimdocument.com/" class="u-image u-logo u-image-1" data-image-width="188" data-image-height="100" title="Kim Technologies">
                <div class="u-header-logo u-logo-image u-logo-image-1"></div>
            </a>
        </div>
    </header>
    <section class="u-align-center u-clearfix u-section-1" id="carousel_8db2">
        <div class="u-align-left u-container-style u-expanded-width-lg u-expanded-width-md u-expanded-width-xl u-group u-image u-image-1" data-image-width="150" data-image-height="100">
            <div class="u-container-layout u-container-layout-1">
                <h1 class="u-text u-text-palette-1-dark-1 u-title u-text-1"></h1>
                <h2 class="u-subtitle u-text u-text-palette-1-dark-1 u-text-2">You can close this window. Thank you.</h2>
                <br />
                <h2 class="u-subtitle u-text u-text-palette-1-dark-1 u-text-2"><a href="https://kimdocument.com/">Return to home</a></h2>
                <div class="u-FlexInfoColumns-1">
                </div>
            </div>
        </div>
    </section>

    <footer class="u-align-center u-clearfix u-footer u-grey-80 u-footer" id="sec-e947">
        <div class="u-clearfix u-sheet u-sheet-1">
            <p class="u-small-text u-text u-text-variant u-text-1">${branding.appName} - Copyright ${(new Date().getFullYear()).toString()}<br>Kim Technologies <a href="https://www.ask.kim" class="u-active-none u-border-none u-btn u-button-link u-button-style u-hover-none u-none u-text-palette-1-base u-btn-1">www.ask.kim</a>
                <br>
                <br>
            </p>
        </div>
    </footer>

</body>

</html>
`;


    useEffect(() => {
        setHtml(template);
        //getAppSettings()
        setTimeout(function () {
            var el = document.getElementById("divTemplate") as HTMLElement;
            el.hidden = false;

            var url_string = window.location.href;
            var url = new URL(url_string);
            sessionStorage.setItem(
                "session.oauth",
                url.searchParams.toString()
            );
            localStorage.setItem("local.oauth", url.searchParams.toString());

            microsoftTeams.initialize();
            microsoftTeams.authentication.notifySuccess("key");

            window.close();
        }, 1000);
    }, []);

    return (
        <div
            hidden
            dangerouslySetInnerHTML={{ __html: _html }}
            id="divTemplate"
        />
    );
}

export default Callback;
